<template>
  <p class="opc-price-bill-text-tips" :class="[mxIsSimplifyForProEdit ? 'opc-price-bill-text-tips-simplify' : '']">
    {{ $t(`billing.payment_tips_for_annual_billed_monthly`) }}
  </p>
</template>

<script>
import simplifyForProMixin from '@/plans/ZOOM_MEETING/mixin/simplify-for-pro.js';
export default {
  mixins: [simplifyForProMixin],
  name: 'PriceBillTextTips',
};
</script>

<style lang="scss" scoped>
.opc-price-bill-text-tips {
  color: var(--zoom-color-text-neutral, #686F79);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin: 16px auto;
  &.opc-price-bill-text-tips-simplify {
    margin-top: 20px;
  }
}
</style>
